import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VSheet,
    {
      staticClass: "d-flex align-center",
      class: _setup.isMobile ? "px-2 pt-2 mb-2" : "px-6 py-4",
    },
    [
      _c(
        "div",
        { staticClass: "head-wrapper" },
        [
          _c("div", { staticClass: "text-h6 text--text" }, [
            _vm._v("\n      " + _vm._s(_setup.title) + "\n    "),
          ]),
          _vm._v(" "),
          _setup.isFilterListVisible
            ? _c(_setup.AppointmentTypeFilterList, {
                attrs: { "place-types": _setup.placeTypes },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(VSpacer),
      _vm._v(" "),
      !_setup.isMobile && _setup.filterType !== "telemed"
        ? _c(
            VBtn,
            {
              staticClass: "primary--text align-self-end",
              attrs: { color: "bg-primary", depressed: "" },
              on: { click: _setup.handlePopupMapButtonClick },
            },
            [
              _c(VIcon, { staticClass: "mr-2" }, [
                _vm._v("\n      ui-icon-place\n    "),
              ]),
              _vm._v("\n    " + _vm._s(_setup.maps) + "\n  "),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }